import { observer } from 'mobx-react-lite';
import MainView from './components/MainView';
import TrxView from './components/TrxView';
import TokenView from './components/TokenView';
import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import FooterBar from '@/components/navbar/FooterBar';
import SendView from './components/SendView';
import useHome from './useHome';
import SendCheckView from './components/SendCheckView';
import { truncateString } from '@/utils';
import ReceiveView from './components/ReceiveView';
import HomeHeader from './components/HomeHeader';

const Home = observer(() => {
  const {
    activeTab,
    trxPrice,
    tokenPrice,
    selectedAsset,
    viewType,
    defaultMemo,
    memo,
    activities,
    isNotActivities,
    isWritting,
    sendAddress,
    sendAsset,
    curculateKrw,
    trxAsset,
    tokenAsset,
    totalBalance,
    trxAddress,
    trxTransactions,
    tokenTransactions,
    trxBalance,
    trxKrw,
    tokenBalance,
    tokenKrw,
    isSendCheckBtnDisabled,
    isFeeNotice,
    fee,
    isSendingAsset,
    dbsBuyCount,
    dbsBuyCountKRW,
    isCancelModalOpen,
    isSendCompleteModalOpen,
    isFeeNoticeModalOpen,
    isInvalidAddressModalOpen,
    onClickSendCompleteModalConfirm,
    onClickFeeNoticeModalClose,
    resetSendInfo,
    onClickCopyBtn,
    onClickResetBtn,
    onClickViewType,
    onClickSendBtn,
    onClickBackBtn,
    onChangeSendAddress,
    onChangeSelectedAsset,
    onClickDeleteBtn,
    onClickResetAmountBtn,
    onPaste,
    onChangeSelectedAssetValue,
    onClickSendCheckBtn,
    onClickInvalidAddressModalClose,
    isBalanceNotEnoughModalOpen,
    onClickBalanceNotEnoughModalConfirm,
    isTransactionErrorModalOpen,
    transactionErrorMessage,
    onClickTransactionErrorModalClose,
    isClipboardErrorModalOpen,
    onClipboardError,
    onClickClipboardErrorModalClose,
    onClickSendCancelBtn,
    onClickCancelModalClose,
    onClickCancelModalYes,
    onClickBacktoSendView,
    onClickSendCheckNextBtn,
    onMoveMainView,
    onClickCameraBtn,
    onResetSelectedAsset,
    onClickActiveTab,
    onClickPrevTransactionBtn,
    onKeyPress,
    onChangeMemo,
    onSetMemo,
  } = useHome();

  return (
    <div className="main-container sub-container">
      <HomeHeader viewType={viewType} onClickBackBtn={onClickBackBtn} />
      {viewType === HomeViewType.MAIN && (
        <MainView
          activeTab={activeTab}
          trxKrw={trxKrw}
          tokenKrw={tokenKrw}
          tokenBalance={tokenBalance}
          trxBalance={trxBalance}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          totalBalance={totalBalance}
          trxAddress={trxAddress}
          activities={activities}
          isNotActivities={isNotActivities}
          isSendingAsset={isSendingAsset}
          dbsBuyCount={dbsBuyCount}
          dbsBuyCountKRW={dbsBuyCountKRW}
          trxPrice={trxPrice}
          tokenPrice={tokenPrice}
          isTransactionErrorModalOpen={isTransactionErrorModalOpen}
          transactionErrorMessage={transactionErrorMessage}
          onClickCopyBtn={onClickCopyBtn}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onClickSendBtn={onClickSendBtn}
          onClickActiveTab={onClickActiveTab}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
          onClickTransactionErrorModalClose={onClickTransactionErrorModalClose}
        />
      )}
      {viewType === HomeViewType.SOL && (
        <TrxView
          trxPrice={trxPrice}
          trxTransactions={trxTransactions}
          trxBalance={trxBalance}
          trxKrw={trxKrw}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onResetSelectedAsset={onResetSelectedAsset}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
          onClickCopyBtn={onClickCopyBtn}
        />
      )}
      {viewType === HomeViewType.TOKEN && (
        <TokenView
          tokenTransactions={tokenTransactions}
          tokenBalance={tokenBalance}
          tokenKrw={tokenKrw}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onResetSelectedAsset={onResetSelectedAsset}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
          onClickCopyBtn={onClickCopyBtn}
        />
      )}
      {viewType === HomeViewType.SEND && (
        <SendView
          defaultMemo={defaultMemo}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          isInvalidAddressModalOpen={isInvalidAddressModalOpen}
          isBalanceNotEnoughModalOpen={isBalanceNotEnoughModalOpen}
          isClipboardErrorModalOpen={isClipboardErrorModalOpen}
          selectedAsset={selectedAsset}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          isWritting={isWritting}
          sendAddress={sendAddress}
          sendAsset={sendAsset}
          curculateKrw={curculateKrw}
          onKeyPress={onKeyPress}
          onChangeMemo={onChangeMemo}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickInvalidAddressModalClose={onClickInvalidAddressModalClose}
          onClickBalanceNotEnoughModalConfirm={onClickBalanceNotEnoughModalConfirm}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onChangeSelectedAsset={onChangeSelectedAsset}
          onChangeSendAddress={onChangeSendAddress}
          onClickDeleteBtn={onClickDeleteBtn}
          onClickResetAmountBtn={onClickResetAmountBtn}
          onPaste={onPaste}
          onChangeSelectedAssetValue={onChangeSelectedAssetValue}
          onClickCameraBtn={onClickCameraBtn}
          onSetMemo={onSetMemo}
          memo={memo}
          onClipboardError={onClipboardError}
          onClickClipboardErrorModalClose={onClickClipboardErrorModalClose}
        />
      )}
      {viewType === HomeViewType.SEND_CHECK && (
        <SendCheckView
          fee={fee}
          isFeeNotice={isFeeNotice}
          trxBalance={trxBalance}
          selectedAsset={selectedAsset}
          sendAsset={sendAsset}
          curculateKrw={curculateKrw}
          trxAddress={truncateString(trxAddress)}
          sendAddress={truncateString(sendAddress)}
          isCancelModalOpen={isCancelModalOpen}
          isSendCompleteModalOpen={isSendCompleteModalOpen}
          isFeeNoticeModalOpen={isFeeNoticeModalOpen}
          onClickBacktoSendView={onClickBacktoSendView}
          onClickSendCheckNextBtn={onClickSendCheckNextBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onClickCancelModalClose={onClickCancelModalClose}
          onClickCancelModalYes={onClickCancelModalYes}
          onClickSendCompleteModalConfirm={onClickSendCompleteModalConfirm}
          onClickFeeNoticeModalClose={onClickFeeNoticeModalClose}
        />
      )}
      {viewType === HomeViewType.RECEIVE && <ReceiveView address={trxAddress} onClickCopyBtn={onClickCopyBtn} />}
      <FooterBar
        activeTab={activeTab}
        viewType={viewType}
        onMoveMainView={onMoveMainView}
        onResetSelectedAsset={onResetSelectedAsset}
        onChangeTabType={onClickActiveTab}
        resetSendInfo={resetSendInfo}
      />
    </div>
  );
});

export default Home;
